export default __webpack_public_path__ + "static/media/shieldsweep5.4281405a.png";